import { get } from 'lodash';
import { withMeta } from '@/helpers/dataLayer';
import { mapActions, mapState } from 'vuex';
import loaderMixin from '@/mixins/loader';
import documentUploadMixin from '@/mixins/documentUpload';
import { formMixin, validators } from '@/components/forms/mixin';
import getValidationMessage from '@/helpers/getValidationMessage';
import { isNumber } from '@/utils/helpers';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import promoCodeMixin from '@/mixins/promoCode';
import depositWarningMixin from '@/mixins/depositWarningMixin';
import depositDisclaimer from '@/components/wallet/shared/deposit-disclaimer/deposit-disclaimer.vue';
import depositAmountPicker from '@/components/wallet/shared/deposit-amount-picker/deposit-amount-picker.vue';
import feeWaivedBanner from '@/components/wallet/shared/fee-waived-banner/fee-waived-banner.vue';
import { DEPOSIT_METHOD_TYPE } from '@/components/wallet/shared/depositMethodTypes';
import contentLoaderMixin from '@/mixins/contentLoader';

const AMOUNT_STEP_ONE = 10;
const AMOUNT_STEP_THREE = 50;
const AMOUNT_STEP_FOUR = 100;

export default {
  mixins: [
    documentUploadMixin,
    formMixin,
    loaderMixin,
    promoCodeMixin,
    depositWarningMixin,
    contentLoaderMixin,
  ],
  components: {
    depositDisclaimer,
    depositAmountPicker,
    feeWaivedBanner,
  },
  data() {
    return {
      depositMethodType: DEPOSIT_METHOD_TYPE.CRYPTO,
      errorMessage: '',
      canDeposit: false,
      isComponentReady: false,
      fields: {
        amount: '',
      },
      depositAmounts: [
        AMOUNT_STEP_ONE,
        AMOUNT_STEP_THREE,
        AMOUNT_STEP_FOUR,
      ],
    };
  },
  validations() {
    return {
      fields: {
        amount: validators.depositAmountCoinbase(
          this.minimumDepositAmount, this.maximumDepositAmount),
      },
    };
  },
  methods: {
    ...mapActions('wallet', ['getDepositUSDCoin']),
    ...mapActions('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions']),
    handleAmountBlur() {
      this.$gtm.trackEvent(withMeta({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'fill',
        label: 'Amount',
      }));
    },
    onUpdateAmount(amount) {
      if (this.fields.amount === '') {
        this.fields.amount = amount;
      } else if (isNumber(this.fields.amount)) {
        this.fields.amount = Number(this.fields.amount) + amount;
      }
      this.$gtm.trackEvent(withMeta({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: `Amount ${amount} Button`,
      }));
    },
    onSubmit() {
      this.$gtm.trackEvent(withMeta({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Deposit',
      }));
      this.setCurrentSmallPopup(MODALS.COINBASE);
      this.setCurrentPopupOptions({ depositPayload: this.depositPayload });
    },
  },
  computed: {
    ...mapState('wallet', ['minimumDepositAmount']),
    maximumDepositAmount() {
      return 99999;
    },
    depositPayload() {
      return {
        amount: this.fields.amount,
        depositPromoCode: '',
        marketingSource: '',
        marketingProgram: '',
      };
    },
    amountHasError() {
      return this.$v.fields.amount.$error;
    },
    amountValidationMessage() {
      return getValidationMessage(this.$v.fields.amount);
    },
    isConfirmDisabled() {
      return this.invalidOrDisabled || !this.canDeposit;
    },
  },
  mounted() {
    this.getDepositUSDCoin()
    .then((data) => {
      this.checkDocumentUploadFlags(data);
      this.promoCodeDetail = data.promoCodeDetail || {};
      this.canDeposit = data.canDeposit;
      this.errorMessage = data.errorMessage || '';
      this.isComponentReady = true;
    })
    .catch((error) => {
      this.isComponentReady = true;
      this.errorMessage = get(error, 'response.data.message', null);
      this.checkDocumentUploadFlags(get(error, 'response.data', {}));
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/add-funds-coinbase/add-funds-coinbase.js